export default "__VITE_ASSET__fe127b2e__"